import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { makeStyles, Typography, CircularProgress } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { QRCodeSVG } from 'qrcode.react'
import { useIntl } from 'react-intl'
import { CapeeshColors } from '../../../assets/ColorPalette'
import { STUDENT_URL } from '../../../_state/helpers'
import { studentActions } from '../../../_state/actions'
import { studentScreenMessages } from '../StudentScreen.i18n.Messages'

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: 16,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        minWidth: 320,
    },
    accessCode: {
        fontSize: 40,
        fontWeight: 700,
        letterSpacing: 6,
        color: CapeeshColors.Primary600 || '#1976d2',
        textAlign: 'center',
        padding: '8px 16px',
        backgroundColor: '#f5f5f5',
        borderRadius: 8,
        fontFamily: 'monospace',
    },
    expiry: {
        fontSize: 13,
        color: CapeeshColors.Gray1 || '#8E8E93',
    },
    instructions: {
        fontSize: 14,
        color: '#555',
        textAlign: 'center',
        maxWidth: 320,
        lineHeight: 1.5,
    },
    qrWrapper: {
        padding: 12,
        backgroundColor: '#fff',
        borderRadius: 8,
        border: '1px solid #eee',
    },
    copyButton: {
        backgroundColor: CapeeshColors.BlueBright || '#2196f3',
        color: 'white',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: '#1565c0',
        },
    },
    closeButton: {
        color: CapeeshColors.Gray1 || '#8E8E93',
    },
}))

const StudentAccessCodeDialog = ({ open, onClose, student, dispatch }) => {
    const classes = useStyles()
    const intl = useIntl()

    useEffect(() => {
        if (open) {
            dispatch(studentActions.createSelfAccessCode())
        }
    }, [open])

    const accessCode = student.selfAccessCode?.accessCode
    const loginUrl = accessCode ? `${STUDENT_URL}login/?accessCode=${accessCode}` : ''

    const handleCopyLink = () => {
        if (loginUrl) {
            navigator.clipboard.writeText(loginUrl)
        }
    }

    return (
        <Dialog onClose={onClose} open={open} maxWidth="sm">
            <div className={classes.dialog}>
                <DialogTitle style={{ display: 'flex', justifyContent: 'center' }}>
                    {intl.formatMessage(studentScreenMessages.loginOnAnotherDevice)}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.content}>
                        {student.isFetchingSelfAccessCode && <CircularProgress size={40} />}

                        {accessCode && (
                            <React.Fragment>
                                <Typography className={classes.instructions}>
                                    {intl.formatMessage(studentScreenMessages.accessCodeInstructions)}
                                </Typography>

                                <div className={classes.accessCode}>
                                    {accessCode}
                                </div>

                                <Typography className={classes.expiry}>
                                    {intl.formatMessage(studentScreenMessages.accessCodeExpiry)}
                                </Typography>

                                <div className={classes.qrWrapper}>
                                    <QRCodeSVG
                                        value={loginUrl}
                                        size={200}
                                        level="M"
                                        includeMargin={false}
                                    />
                                </div>

                                <Typography className={classes.instructions}>
                                    {intl.formatMessage(studentScreenMessages.accessCodeQrHint)}
                                </Typography>
                            </React.Fragment>
                        )}
                    </div>
                </DialogContent>
                <DialogActions style={{ marginTop: 10, gap: 4, justifyContent: 'center' }}>
                    {accessCode && (
                        <Button className={classes.copyButton} onClick={handleCopyLink}>
                            {intl.formatMessage(studentScreenMessages.copyLoginLink)}
                        </Button>
                    )}
                    <Button className={classes.closeButton} onClick={onClose}>
                        {intl.formatMessage(studentScreenMessages.close)}
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    )
}

const mapStateToProps = (state) => ({
    student: state.student,
})

export default connect(mapStateToProps)(StudentAccessCodeDialog)
